module.exports = __webpack_public_path__ + "img/wxImg.80257ee5.png";